import * as React from "react";

export interface ThrowClassNameToChildrenProps {
    className?: string;
    children: undefined | React.ReactNode;
}

export function ThrowClassNameToChildren(props: ThrowClassNameToChildrenProps): JSX.Element | null {
    if (!props.children) {
        return null;
    }
    return (
        <>
            {React.Children.map(props.children, child =>
                React.isValidElement(child)
                    ? React.cloneElement<ThrowClassNameToChildrenProps>(
                          child as React.ReactElement<ThrowClassNameToChildrenProps>,
                          { className: props.className }
                      )
                    : child
            )}
        </>
    );
}
